import React from "react";

import { componentNanoid } from "../../utils/componentNanoid";
import formatSearchResults from "../SearchContents/formatSearchResults";
import { composeCards } from "../SearchResultCardList/composeCards";
import { useSearchResults } from "../../context/DataContext";
import GlobalCard from "./GlobalCard";
import { ResultColumn } from "../SearchContents/SearchResults";

import styles from "./SearchResultGlobal.module.css";

export type SearchResultsGlobalProps = {
    itemDefs: ResultColumn[];
};

export const SearchResultsGlobal = ({ itemDefs }: SearchResultsGlobalProps) => {
    const { results, resultsSummary: summary } = useSearchResults();
    const rawItems = formatSearchResults(results, itemDefs);
    const items = composeCards(itemDefs, rawItems);

    const maybeCards = items.length ? (
        <ol start={summary.currStart} className={styles.resultsCards}>
            {items.map((parts) => (
                <GlobalCard parts={parts} key={`card-${componentNanoid()}`} />
            ))}
        </ol>
    ) : null;
    return maybeCards;
};

export default SearchResultsGlobal;
